module.exports = __webpack_public_path__ + "img/check-box-icon.5a1be393.svg";